if (!window.Eurus) { window.Eurus = { loadedScript: [] }; }
if (!window.Eurus.loadedScript) { window.Eurus.loadedScript = []; }

if (!window.Eurus.loadedScript.includes('quiz-test.js')) {
  window.Eurus.loadedScript.push('quiz-test.js');

  function registerQuizTestComponent() {
    if (!window.Alpine || !window.Alpine.data) return false;
    if (window.Alpine.__quizTestRegistered) return true;
    window.Alpine.__quizTestRegistered = true;

    Alpine.data('xQuizTest', (config) => ({
      sectionId: config.sectionId,
      rawQuestions: config.questions || [],
      rawResults: config.results || [],
      pharmacistAvatar: config.pharmacistAvatar || '',
      pharmacistAvatarAlt: config.pharmacistAvatarAlt || '',
      
      debugMode: config.debugMode || false,

      // Stato
      state: 'question',
      questions: [],
      results: [],
      questionsPath: [],
      skipQuestions: [],
      history: [], 
      currentQuestionId: null,
      currentQuestion: null,
      currentChoices: [],
      selectedIndex: null,
      
      // Calcoli
      answersGiven: 0,
      score: 0,
      
      // UI / UX
      isFading: false,
      isCalculating: false, 
      matchedResult: null,

      init() {
        this.questions = this.normalizeQuestions(this.rawQuestions);
        this.results = this.normalizeResults(this.rawResults);

        if (this.questions.length === 0) return;

        this.questionsPath = this.questions.map(q => q.id);
        this.currentQuestionId = this.questionsPath[0];
        
        this.updateDebugBox();
        this.renderCurrentQuestion();
      },

      updateDebugBox() {
        if (!this.debugMode) {
          const existingBox = document.getElementById('quiz-debug-score');
          if (existingBox) existingBox.remove();
          return;
        }

        let debugBox = document.getElementById('quiz-debug-score');
        if (!debugBox) {
          debugBox = document.createElement('div');
          debugBox.id = 'quiz-debug-score';
          debugBox.style.cssText = 'position: fixed; bottom: 20px; right: 20px; background: #e11d48; color: white; padding: 10px 20px; font-weight: bold; border-radius: 8px; z-index: 9999; box-shadow: 0 4px 6px rgba(0,0,0,0.3); font-family: sans-serif; pointer-events: none;';
          document.body.appendChild(debugBox);
        }
        debugBox.innerHTML = 'Punteggio: ' + this.score;
      },

      handleKeydown(e) {
        if (this.state !== 'question' || this.isFading || this.selectedIndex !== null) return;
        const key = e.key.toUpperCase();
        const validKeys = ['A','B','C','D','E'];
        const index = validKeys.indexOf(key);
        
        if (index !== -1 && index < this.currentChoices.length) {
          this.selectChoice(index);
        }
      },

      normalizeQuestions(raw) {
        return raw.map(q => {
          const id = parseInt(q.id, 10);
          if (!id) return null;
          const choices = (q.choices || []).map(c => ({
            label: c.label || '',
            score: parseInt(c.score, 10) || 0,
            skip: (c.skip || '').toString().split(',').map(x => parseInt(x.trim(), 10)).filter(x => !isNaN(x)),
            jumpToResult: !!c.jumpToResult
          }));
          return { id, question_text: q.question_text || '', infotip: q.infotip || '', choices };
        }).filter(Boolean).sort((a, b) => a.id - b.id);
      },

      normalizeResults(raw) {
        return raw.map(r => {
          const scoreExact = parseInt(r.scoreExact, 10);
          if (isNaN(scoreExact) || scoreExact === 0) return null;
          const rangeRaw = r.scoreRangeMax;
          const scoreRangeMax = (rangeRaw === null || rangeRaw === '') ? null : parseInt(rangeRaw, 10);
          return { blockId: r.blockId, scoreExact, scoreRangeMax };
        }).filter(Boolean);
      },

      get currentQuestionNumber() {
        if (!this.currentQuestionId) return 1;
        const idx = this.questionsPath.indexOf(this.currentQuestionId);
        return idx >= 0 ? idx + 1 : 1;
      },

      get progressPercent() {
        if (this.state !== 'question') return 100;
        if (this.questionsPath.length === 0) return 0;
        return Math.min(100, (this.answersGiven / this.questionsPath.length) * 100);
      },

      renderCurrentQuestion() {
        const q = this.questions.find(x => x.id === this.currentQuestionId);
        if (!q) { 
          this.showResult(); 
          return; 
        }
        this.currentQuestion = q;
        this.currentChoices = q.choices;
        this.selectedIndex = null;
      },

      selectChoice(index) {
        if (this.selectedIndex !== null) return;
        const choice = this.currentChoices[index];
        if (!choice) return;

        this.history.push({
          questionId: this.currentQuestionId,
          score: this.score,
          answersGiven: this.answersGiven,
          questionsPath: [...this.questionsPath],
          skipQuestions: [...this.skipQuestions]
        });

        this.selectedIndex = index;
        this.score += choice.score;
        this.answersGiven++;

        this.updateDebugBox();

        if (this.isFirstQuestion() && choice.skip && choice.skip.length > 0) {
          this.skipQuestions = choice.skip.slice();
          this.questionsPath = this.questions.map(q => q.id).filter(id => !this.skipQuestions.includes(id));
        }

        const nextIdx = this.questionsPath.indexOf(this.currentQuestionId) + 1;
        const isGoingToResult = choice.jumpToResult || (nextIdx >= this.questionsPath.length);

        this.transition(() => {
          if (choice.jumpToResult) { 
            this.showResult(); 
          } else {
            this.advance();
          }
        }, isGoingToResult);
      },

      goBack() {
        if (this.history.length === 0) return;
        const lastState = this.history.pop();
        
        this.currentQuestionId = lastState.questionId;
        this.score = lastState.score;
        this.answersGiven = lastState.answersGiven;
        this.questionsPath = lastState.questionsPath;
        this.skipQuestions = lastState.skipQuestions;

        this.updateDebugBox();

        this.state = 'question';
        this.matchedResult = null;
        this.isCalculating = false;
        
        this.transition(() => this.renderCurrentQuestion(), false);
      },

      isFirstQuestion() { 
        return this.currentQuestionId === this.questionsPath[0] && this.answersGiven === 1; 
      },

      advance() {
        const currentIdx = this.questionsPath.indexOf(this.currentQuestionId);
        const nextIdx = currentIdx + 1;
        
        if (nextIdx < this.questionsPath.length) {
          this.currentQuestionId = this.questionsPath[nextIdx];
          this.renderCurrentQuestion();
        } else {
          this.showResult();
        }
      },

      showResult() {
        this.matchedResult = this.findMatchingResult(this.score);

        if (!this.matchedResult) {
          this.matchedResult = { blockId: 'fallback-collection' };
        }

        this.state = 'show_result';
        this.isCalculating = true; 
        
        this.$nextTick(() => {
          setTimeout(() => {
            this.isCalculating = false;
          }, 1500);
        });
      },

      findMatchingResult(score) {
        let match = this.results.find(r => r.scoreExact === score);
        if (match) return match;
        
        match = this.results.find(r => r.scoreRangeMax !== null && score >= r.scoreExact && score <= r.scoreRangeMax);
        return match || null;
      },

      scrollToTarget(targetId) {
        const target = document.getElementById(targetId);
        
        if (target) {
          const headerHeight = 120; 
          const extraOffset = 40;   
          
          const targetPosition = target.getBoundingClientRect().top + window.scrollY;
          
          window.scrollTo({
            top: targetPosition - headerHeight - extraOffset,
            behavior: 'smooth'
          });
        }
      },

      transition(callback, isGoingToResult = false) {
        if (!isGoingToResult) {
          this.scrollToTarget('quiz-question-container');
        }
        
        this.isFading = true;
        
        setTimeout(() => {
          callback(); 
          
          this.$nextTick(() => { 
            this.isFading = false; 
            
            if (isGoingToResult) {
              setTimeout(() => {
                this.scrollToTarget('quiz-test-results-area');
              }, 50);
            }
          });
        }, 300);
      },

      restart() {
        this.score = 0;
        this.answersGiven = 0;
        this.skipQuestions = [];
        this.history = []; 
        this.questionsPath = this.questions.map(q => q.id);
        this.currentQuestionId = this.questionsPath[0];
        this.selectedIndex = null;
        this.matchedResult = null;
        this.isCalculating = false;
        this.state = 'question';
        
        this.updateDebugBox();
        this.transition(() => this.renderCurrentQuestion(), false);
      }
    }));

    return true;
  }

  if (!registerQuizTestComponent()) { 
    document.addEventListener('alpine:init', registerQuizTestComponent); 
  } else {
    requestAnimationFrame(() => {
      document.querySelectorAll('.quiz-test-wrapper').forEach((el) => {
        if (!el._x_dataStack && window.Alpine && Alpine.initTree) { 
          Alpine.initTree(el); 
        }
      });
    });
  }
}